var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.5 0.5L18.75 32.6875L4.5 14L0 18.5625L18.75 37.3125L50 6.0625L44.5 0.5Z","fill":"black"}));
}

CheckmarkInline.defaultProps = {"width":"50","height":"38","viewBox":"0 0 50 38","fill":"none"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
